import React from 'react'
import { debounce } from 'lodash'
import * as R from 'ramda'

export const useAsyncSelect = (fetchHandler, matcher, transformData) => {
  const [offset] = React.useState(0)
  const [isFetching, setIsFetching] = React.useState(true)

  const loadOptions = React.useCallback(
    async (search, callback) => {
      setIsFetching(true)

      try {
        const { response = {} } = await fetchHandler({
          limit: 50,
          offset,
          search,
        })

        const results = response?.results ?? []

        callback(
          R.map(matcher, transformData ? transformData(results) : results),
        )
      } catch (error) {
        console.error(error)
      } finally {
        setIsFetching(false)
      }
    },
    [matcher, offset, fetchHandler],
  )

  return {
    state: { isFetching },
    handlers: {
      loadOptions: debounce(loadOptions, 500, { trailing: true }),
    },
  }
}
